import {Button, Stack, Typography, useTheme} from '@mui/material';
import {AlertModal} from 'presentation/components';
import Icon from 'presentation/icons';
import {translations} from 'presentation/translations-new';
import React from 'react';
import {SucessSubscriptionDialogProps} from './types';
import {
	StyledConfirmButtonContainer,
	StyledDivider,
	StyledFooterDescriptionContainer,
	StyledIconPosition,
	StyledProtocolRow,
	StyledSectionDescription,
} from './styles';

const {sucessSubscriptionDialog} = translations['pt-br'].privateFlow.home;

export function SucessSubscriptionDialog({
	open,
	onBack,
	email,
	protocolValue,
	isBemobiFlow = false,
	dataTagId,
}: SucessSubscriptionDialogProps) {
	const theme = useTheme();
	const title = isBemobiFlow
		? sucessSubscriptionDialog.titleBemobi
		: sucessSubscriptionDialog.title;
	const line2 = isBemobiFlow
		? sucessSubscriptionDialog.line2Bemobi
		: sucessSubscriptionDialog.line2;
	const line5 = isBemobiFlow
		? sucessSubscriptionDialog.line5Bemobi
		: sucessSubscriptionDialog.line5;
	return (
		<AlertModal
			headerDataTagId={dataTagId?.header}
			closeBtnDataTagId={dataTagId?.closeButton}
			padding={'12px 24px 8px'}
			open={open}
			onClose={onBack}
			variant="success"
			headerTitle={sucessSubscriptionDialog.header}
			title={title}
			subDescription={
				<StyledSectionDescription>
					<Typography>
						<Typography>{sucessSubscriptionDialog.line1}</Typography>
						{line2}
						<b>{email}</b>
						{sucessSubscriptionDialog.line3}
					</Typography>
					<StyledProtocolRow>
						<StyledIconPosition>
							<Icon
								name="assignment-filled"
								color={theme.colors.brand.primary.blue}
								size={16}
							/>
						</StyledIconPosition>
						<Stack>
							<Typography color={'text.secondary'}>
								{sucessSubscriptionDialog.protocol}
							</Typography>
							<Typography color={'text.primary'}>{protocolValue}</Typography>
						</Stack>
					</StyledProtocolRow>
					<StyledFooterDescriptionContainer variant="helperText">
						<StyledDivider />
						<Typography variant="helperText" component={'p'}>
							{sucessSubscriptionDialog.line4}
						</Typography>
						<Typography variant="helperText">{line5}</Typography>
					</StyledFooterDescriptionContainer>
				</StyledSectionDescription>
			}
			footerContent={
				<StyledConfirmButtonContainer>
					<Button onClick={onBack} data-tag-id={dataTagId?.understandButton}>
						{sucessSubscriptionDialog.confirmButton}
					</Button>
				</StyledConfirmButtonContainer>
			}
		/>
	);
}
